import { Pipe, PipeTransform } from '@angular/core';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { LocalizationHelper } from '../helpers/localization.helper';
import { LocalizationService } from '../services/localization.service';

@Pipe({ name: 'booleanHR', pure: false })
export class BooleanHRPipe implements PipeTransform {
  private readonly locHelper = new LocalizationHelper(this.ls);

  constructor(private ls: LocalizationService) {}

  transform(value: boolean, capitalize: boolean = true): string {
    const val = this.locHelper.yesNo(value);
    if (capitalize) return StrHlp.capitalize(val);
    else return val;
  }
}
